import { ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class UpdateRawGenericMappingCommand extends ModelBase {
    public rawGenericMappingID: number = 0;

    public staticFileSpecID: number = 0;

    public rawGenericSourceTableName: string = "";

    public rawGenericSourceField: string = "";

    public rawGenericDestinationTableName: string = "";

    public rawGenericDestinationField: string = "";

    public defaultValue: string | null = null;

    public calculation: string | null = null;

    public genericJoinFieldInd: boolean = false;

    public iteration: number = 0;

    public destinationTableId: number = 0;

    public destinationFieldId: number = 0;
}